import wwJsApi from '@/plugins/wxworkJsapi.js'

const actions = {
  CHANGE_NAV_INDEX({ commit }, _index) {
    commit('CHANGE_NAV_INDEX', _index)
  },
  CHANGE_NAV_MODULE({ commit }, _module) {
    commit('CHANGE_NAV_MODULE', _module)
  },
  CHANGE_USER_ROLE({ commit }, _user) {
    commit('CHANGE_USER_ROLE', _user)
  },
  // 注意，调用此方法需要在wxworkJsapi的 initWecomSdk() 之后
  getExtContact({ commit }, userId) {
    return new Promise((resolve, reject) => {
      wwJsApi.getExternalContact(userId)
        .then(resp => {
          console.log('store.actions: getExtContact', resp)
          const data = {
            external_contact: resp.external_contact,
            follow_user: resp.follow_user
          }
          commit('wwContact', data)
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 注意，调用此方法需要在wxworkJsapi的 initWecomSdk() 之后
  getCppContact({ commit }, userId) {
    return new Promise((resolve, reject) => {
      wwJsApi.getCppContact(userId)
        .then(data => {
          console.log('store.actions: getCppContact', data)
          commit('cppContact', data)
          resolve(data)
        })
        .catch(err => {
          console.log(err)
        })
    })
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/actions.js